import styled, { css } from "styled-components";
import {
  biggerFirstLetter,
  content,
  glass,
  medium,
  mobileOnly,
  topText,
} from "../common/styles/mixins";

export const Content = styled.div.attrs({ className: "content" })`
  ${content()}
  display: flex;
  gap: 1.5em;
  align-items: center;
  ${mobileOnly(css`
    flex-direction: column;
    font-size: 0.85em;
  `)}
  .glass {
    ${glass()}
  }
  h1 {
    font-size: 2em;
    margin: 0;
  }
  .glass {
    font-weight: 300;
    padding: 1.5em;
  }
  .publishing_date {
    font-size: 0.8em;
  }
  .share-icons {
    margin-top: 0.6em;
    button + button {
      margin-left: 0.25em;
    }
  }
  .translated {
    font-size: 0.65em;
    opacity: 0.8;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Main = styled.main`
  ${content({
    extraLarge: 1000,
    large: 800,
  })}
  font-size: 16px;
  p {
    line-height: 3ex;
    text-align: justify;
  }
  h2,
  h3 {
    text-transform: none;
  }
  h2 {
    font-size: 2em;
  }
  h3 {
    font-size: 1.75em;
  }
  h4 {
  }
  ${mobileOnly(css`
    iframe,
    video {
      width: 100%;
      max-width: 90vw;
      height: 100%;
    }
  `)}
  .author {
    display: flex;
    align-items: center;
    margin-top: 2em;
  }
  .top_text {
    font-size: 1.3em;
    ${topText()}
    margin-left: 0.5em;
    margin-top: 0.3em;
    padding-top: 4px;
    h4 {
      display: inline;
      margin: 0;
      font-size: 1.3em;
      font-family: "Bebas Neue Pro Expanded";
      & + h4 {
        margin-left: 0.6ch;
      }
    }
  }
  blockquote {
    border-left: 2px solid white;
    border-bottom: 2px solid white;
    padding-left: 1em;
    font-weight: 300;
    font-style: italic;
  }
  a {
    text-decoration: underline;
  }
  ol {
    li + li {
      margin-top: 0.5em;
    }
  }
`;
